export default [
  {
    path: "/eduitCenter",
    component: () => import("@/views/eduitcenter/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/eduitcenter/home"),
        meta: {
          title: "教育服务专区"
        }
      },
      {
        path: "activityList",
        component: () => import("@/views/eduitcenter/activityList"),
        meta: {
          title: "活动专区"
        }
      },
      {
        path: "studentList",
        component: () => import("@/views/eduitcenter/studentList"),
        meta: {
          title: "学生专区"
        }
      },
      {
        path: "parentList",
        component: () => import("@/views/eduitcenter/parentList"),
        meta: {
          title: "家长专区"
        }
      },
      {
        path: "newsList",
        component: () => import("@/views/eduitcenter/newsList"),
        meta: {
          title: "教育资讯"
        }
      },
      {
        path: "videoCertList",
        component: () => import("@/views/eduitcenter/videoCertList"),
        meta: {
          title: "视频证书"
        }
      },
      {
        path: "studentVideoDetail",
        component: () => import("@/views/eduitcenter/studentVideoDetail"),
        meta: {
          title: "视频详情"
        }
      },
      {
        path: "libraryhome",
        component: () => import("@/views/library/home"),
        meta: {
          title: "市图书馆",keeplive:true
        }
      },
      {
        path: "booklist",
        component: () => import("@/views/library/booklist"),
        meta: {
          title: "我的借阅"
        }
      },
      {
        path: "bookdetail",
        component: () => import("@/views/library/bookdetail"),
        meta: {
          title: "借阅详情"
        }
      },
      {
        path: "provincelibrary",
        component: () => import("@/views/library/provinceLibary"),
        meta: {
          title: "省图书馆"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/eduitCenter.js